<template>
  <div>
      <ToolBar
        :handleToolSide="handleToolSide"
        :handleToolHeadBtn="handleToolHeadBtn"
        :title="title"
        :toolbarIcon="toolbarIcon"
        :toolbarColor="toolbarColor"
      >
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn flat @click.native.stop="saveSettings">
            <v-icon>save</v-icon>
          </v-btn>
        </v-toolbar-items>
      </ToolBar>

    <v-alert
      v-model="saved"
      type="success"
      dismissible
      class="my-0">
      OK
    </v-alert>

    <v-card flat>
      <v-card-text>
        <v-list three-line subheader>
          <v-subheader>Gespan</v-subheader>
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-switch v-model="useSoft"></v-switch>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Filtrage élargi</v-list-tile-title>
              <v-list-tile-sub-title>Prendre en compte les réservations 'brouillon' dans les actions.</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-switch v-model="includeArchive"></v-switch>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Inclure les archives</v-list-tile-title>
              <v-list-tile-sub-title>Inclure les archives dans les requêtes. Attention, ceci peut serieusement ralentir l'application!.</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-subheader>Interface</v-subheader>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>Garder les requêtes</v-list-tile-title>
              <v-list-tile-sub-title>Combien de minutes l'application doit conserver en mémoire les requêtes vers le serveur.</v-list-tile-sub-title>
              <v-slider prepend-icon="schedule" v-model="cacheExpires" thumb-label step="1" max="10" ticks></v-slider>
            </v-list-tile-content>
          </v-list-tile>
          <div class="py-3"/>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>Fréquence de Notifications (relance de page nécessaire)</v-list-tile-title>
              <v-list-tile-sub-title>Combien de minutes d'intervalle entre les recherches de nouvelles notifications.</v-list-tile-sub-title>
              <v-slider prepend-icon="schedule" v-model="notifPoll" thumb-label step="1" min="1" max="10" ticks></v-slider>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ToolBar from '@/components/ToolBar'
export default {
  components: {
    ToolBar,
  },
  data: () => ({
    toolbarColor: 'purple darken-3',
    toolbarIcon: 'home',
    title: 'Configurations',
    saved: false,
  }),
  computed: {
    useSoft: {
      get () { return this.$store.getters['ui/useSoftAvailability'] },
      set (value) { this.$store.dispatch('ui/updateSoft', value) },
    },
    cacheExpires: {
      get () { return this.$store.getters['ui/cacheExpire'] },
      set (value) { this.$store.dispatch('ui/updateCacheExpire', value) },
    },
    notifPoll: {
      get () { return this.$store.getters['ui/notifPoll'] },
      set (value) { this.$store.dispatch('ui/updateNotifPoll', value) },
    },
    includeArchive: {
      get () { return this.$store.getters['ui/includeArchive'] },
      set (value) { this.$store.dispatch('ui/updateArchive', value) },
    },
  },
  methods: {
    handleToolSide () {
      this.$store.dispatch('ui/toggleDrawer', {})
    },
    handleToolHeadBtn () {
      this.$router.push({path: '/'})
    },
    saveSettings () {
      this.$store.dispatch('ui/saveState')
      this.saved = true
    },
  },
}
</script>

<style>

</style>
